/**
 * Brand Word Highlighter — Periscope Depth
 * Automatically wraps the word "disownership" (case-insensitive) in a
 * <span class="brand-word"> inside .gh-content paragraphs.
 * Skips elements that already have the class to avoid double-wrapping.
 */
export default function brandWord() {
    const content = document.querySelector('.gh-content');
    if (!content) return;

    const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_TEXT,
        null
    );

    const matches = [];
    let node;
    while ((node = walker.nextNode())) {
        if (/disownership/i.test(node.nodeValue)) {
            // Skip if already inside a .brand-word span
            if (node.parentElement && node.parentElement.classList.contains('brand-word')) continue;
            matches.push(node);
        }
    }

    matches.forEach((textNode) => {
        const frag = document.createDocumentFragment();
        const parts = textNode.nodeValue.split(/(disownership)/i);
        parts.forEach((part) => {
            if (/^disownership$/i.test(part)) {
                const span = document.createElement('span');
                span.className = 'brand-word';
                span.textContent = part;
                frag.appendChild(span);
            } else {
                frag.appendChild(document.createTextNode(part));
            }
        });
        textNode.parentNode.replaceChild(frag, textNode);
    });
}
